/******************************************
*  Author : Riccardo Di Dato
*  Created On : Thu Dec 30 2021
*  File : Observer.ts
*******************************************/
/* c8 ignore start */
/**
 * Oggetto che definisce il funzionamento di un subscriber iscritto ad un publisher.
 *
 */
export class Observer {
    _next;
    _error;
    _complete;
    closed = false;
    /**
     *
     * @param next comportamento in caso di aggiornamento valore corrente
     * @param error comportamento in caso di errore
     * @param complete comportamento in caso di completamento
     */
    constructor(_next, _error = () => { }, _complete = () => { }) {
        this._next = _next;
        this._error = _error;
        this._complete = _complete;
    }
    next(value) {
        if (!this.isClosed()) {
            this._next(value);
        }
    }
    error(err) {
        if (!this.isClosed()) {
            this._error(err);
        }
    }
    complete() {
        if (!this.isClosed()) {
            this._complete();
        }
    }
    unsubscribe() {
        this.closed = true;
    }
    isClosed() {
        return this.closed;
    }
}
/* c8 ignore stop */ 
